module.exports = __webpack_public_path__ + "static/media/successRateUnderline.f814a113.svg";